import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, MessageCircle } from "lucide-react";
import { AuthShell, Field } from "./Login";
import api, { apiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      window.location.href = data.whatsapp_url;
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Lupa Password" subtitle="Masukkan email untuk menerima tautan reset password.">
      <form onSubmit={submit} className="space-y-4">
          <Field label="Email"><input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="input" /></Field>
          <button type="submit" disabled={busy} data-testid="forgot-submit" className="btn-primary w-full">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><MessageCircle className="h-4 w-4" /> Hubungi Admin via WhatsApp</>}</button>
          <p className="text-center text-sm text-slate-500"><Link to="/login" className="font-semibold text-indigo-600 hover:underline">Kembali ke Login</Link></p>
      </form>
    </AuthShell>
  );
}
